import Dropdown from '@mui/joy/Dropdown'
import MenuButton from '@mui/joy/MenuButton'
import Menu from '@mui/joy/Menu'
import MenuItem from '@mui/joy/MenuItem'
import { useNavigate } from 'react-router-dom'
import Add from '@mui/icons-material/Add'

export const CreateNewCampaignButton = () => {
    const navigate = useNavigate()
    return (
        <Dropdown>
            <MenuButton
                sx={{ marginTop: '2rem' }}
                variant="soft"
                color="primary"
                startDecorator={<Add />}
            >
                Create New
            </MenuButton>
            <Menu>
                <MenuItem
                    onClick={() =>
                        navigate('/merchant/create_ai_quotes_campaign_v2')
                    }
                >
                    AI Quotes Campaign
                </MenuItem>
                <MenuItem
                    onClick={() =>
                        navigate('/merchant/create_blog_campaign_v2')
                    }
                >
                    Blog Campaign
                </MenuItem>
                <MenuItem
                    onClick={() => navigate('/merchant/create_video_campaign')}
                >
                    Video Campaign
                </MenuItem>
            </Menu>
        </Dropdown>
    )
}
